import { CdkTrapFocus } from '@angular/cdk/a11y';
import { NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    type TemplateRef,
} from '@angular/core';

@Component({
    selector: 'qpx-preview-zoom-popover',
    imports: [NgTemplateOutlet],
    template: `@if (content(); as controls) {
        <ng-container [ngTemplateOutlet]="controls" />
    }`,
    styleUrl: './preview-zoom-popover.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        role: 'dialog',
        '[attr.aria-label]': 'label()',
    },
    hostDirectives: [CdkTrapFocus],
})
export class PreviewZoomPopover {
    private readonly focusTrap = inject(CdkTrapFocus);
    public readonly content = input.required<TemplateRef<unknown>>();
    public readonly label = input.required<string>();

    constructor() {
        this.focusTrap.enabled = true;
        this.focusTrap.autoCapture = true;
    }
}
